import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import { MenuItemLink, WithPermissions } from "react-admin";
import { toggleSidebar as toggleSidebarAction } from "ra-core";
import { getTokenField } from "../token";
import Stacked_logo from "../layout/svg/ci-logo-stacked-white.svg";
import { hasAccountActiveSubscription } from '../utils';

const styles = {
  root: {
    boxShadow: "none",
    "& span": {
      color: "white",
    },
    "& .MuiToolbar-regular":{
      height: "4em",
    }
  },
  menuItemLink: {
    color: "#000000",
    textTransform: "uppercase",
    fontSize: "14px",
  },
  logo: {
    width: "100%",
    maxWidth: "140px",
    marginRight: "14px",
  },
  LogoWrapper: {
    maxWidth: "200px",
  },
  accountDropdown: {
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-end',
  },
  active: {
    background: 'rgba(237, 237, 237, 0.3)',
    "&&:hover": {
      background: 'rgba(237, 237, 237, 0.3)',
    },
  },
};

function ButtonAppBar(props) {
  const { classes } = props;
  const path = window.location.href;

  return (
    <AppBar position="static" className={classes.root}>
      <Toolbar>
        <Typography>
          <Button
            onClick={toggleSidebarAction}
            href="#/"
            className={`${classes.LogoWrapper} logo-nav`}
          >
            <img src={Stacked_logo} className={classes.logo} alt="logo" />
          </Button>
        </Typography>
        <WithPermissions
          render={({ permissions }) =>
            permissions === "ROLE_ADMIN" ? (
            <Button className={`${path.includes('accounts') ? `${classes.active}` : ''} accounts-nav`}
              href="#/accounts"
              data-testid="accounts-navbar"
            >
                Accounts
              </Button>
            ) : null
          }
        />
        <Button className={`${path.includes('websites') ? `${classes.active}` : ''} consent-solutions-nav`}
          data-testid="consent-solutions-navbar"
          href="#/websites"
        >
          Consent Solutions
        </Button>
        <Button className={`${path.includes('universal_consent_solutions') ? `${classes.active}` : ''} mobile-consent-solutions-nav`}
          data-testid="mobile-consent-solutions-navbar"
          href="#/universal_consent_solutions"
        >
          Mobile Consent Solutions
        </Button>
        <WithPermissions
          render={({ permissions }) =>
            permissions === "ROLE_ADMIN" ? <StyledTemplatesDropdown /> : null
          }
        />
        <StyledAccountDropdown logout={props.logout} />
      </Toolbar>
    </AppBar>
  );
}

ButtonAppBar.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ButtonAppBar);

class TemplatesDropdown extends React.Component {
  state = {
    anchorEl: null,
  };

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  isAdvancedItemEnabled = () => {
    const path = window.location.href;

    return path.includes('pop_up_templates') || path.includes('declaration_templates') ||
      path.includes('choice_box_templates') || path.includes('compliance_dashboard_settings') ||
      path.includes('cookie_consent_texts');
  };

  render() {
    const { anchorEl } = this.state;
    const { classes } = this.props;

    return (
      <div>
        <Button
          className={`${this.isAdvancedItemEnabled() ? `${classes.active}` : ''}`}
          aria-owns={anchorEl ? "simple-menu" : null}
          aria-haspopup="true"
          onClick={this.handleClick}
        >
          Advanced
        </Button>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
        >
          <MenuItemLink
            className={`${classes.menuItemLink} consent-texts-nav`}
            to="/cookie_consent_texts"
            onClick={this.handleClose}
            primaryText="Consent Texts"
          />
          <MenuItemLink
            className={`${classes.menuItemLink} banner-templates-nav`}
            to="/pop_up_templates"
            onClick={this.handleClose}
            primaryText="Banner Templates"
          />
          <MenuItemLink
            className={`${classes.menuItemLink} declaration-templates-nav`}
            to="/declaration_templates"
            onClick={this.handleClose}
            primaryText="Declaration Templates"
          />
          <MenuItemLink
            className={`${classes.menuItemLink} choice-box-templates-nav`}
            to="/choice_box_templates"
            onClick={this.handleClose}
            primaryText="Choice box Templates"
          />
          <WithPermissions
            render={({ permissions }) =>
              permissions === "ROLE_ADMIN" ? (
                <MenuItemLink
                  className={`${classes.menuItemLink} compliance-dashboard-settings-nav`}
                  to="/compliance_dashboard_settings"
                  onClick={this.handleClose}
                  primaryText="Compliance Dashboard Settings"
                />
              ) : null
            }
          />
        </Menu>
      </div>
    );
  }
}

const StyledTemplatesDropdown = withStyles(styles)(TemplatesDropdown);

class AccountDropdown extends React.Component {
  state = {
    anchorEl: null,
    subscriptionActive: false,
    trialPeriod: false,
    showBanner: false,
    trialPeriodEnds: false,
    isStripe: false,
  };

  handleClick = (event) => {
    const paymentMethod = getTokenField("payment_method");
    const subscriptionActive = hasAccountActiveSubscription()
    const isStripe = paymentMethod === "stripe" || paymentMethod === "billing_system";
    this.setState({subscriptionActive, isStripe, anchorEl: event.currentTarget})
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {

    const { anchorEl, subscriptionActive, isStripe } = this.state,
      { classes, logout } = this.props,
      email = getTokenField("email");
    return (
      <WithPermissions
        render={({ permissions }) => {
          return (
            <div className={classes.accountDropdown}>
              <Button
                aria-owns={anchorEl ? "simple-menu" : null}
                aria-haspopup="true"
                data-testid="account-dropdown-navbar"
                onClick={this.handleClick}
              >
                {email || "Account"}
              </Button>
              <Menu
                id="simple-menu"
                data-testid="logout-button"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={this.handleClose}
              >
                <span className={`${classes.menuItemLink} logout-nav`} data-testid="logout-button">
                  {logout}
                </span>
                {permissions !== "ROLE_ADMIN" && isStripe ? (
                  <MenuItemLink
                    className={`${classes.menuItemLink} account-nav`}
                    to="/account"
                    onClick={this.handleClose}
                    primaryText="account"
                  />
                ) : null}
                {permissions !== "ROLE_ADMIN" &&
                isStripe &&
                !subscriptionActive ? (
                  <MenuItemLink
                    className={`${classes.menuItemLink} subscription-nav`}
                    to="/subscription"
                    onClick={this.handleClose}
                    primaryText="Subscription"
                  />
                ) : null}
              </Menu>
            </div>
          );
        }}
      />
    );
  }
}

const StyledAccountDropdown = withStyles(styles)(AccountDropdown);
